// 招聘管理
export default [
    {
      path: '/recruit',
      name: 'recruit',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/recruit/recruit.vue'], resolve)
      }
    },
    {
        path: '/applicantInfo',
        name: 'applicantInfo',
        meta: {
          requireAuth: true,
          keepAlive: true
        },
        component: (resolve) => {
          require(['@/views/recruit/applicantInfo.vue'], resolve)
        }
      },
    
  
  ]
  


// WEBPACK FOOTER //
// ./src/router/recruit.js